module.exports = __webpack_public_path__ + "static/media/CV MONTASSAR KHEFIFI.3a2764e8.pdf";